<template>
  <div>
    <b-modal
      ref="duplicate-campaign-modal"
      id="duplicate-campaign-modal"
      class="duplicate-campaign-modal"
      size="lg"
      hide-footer
      hide-header
      centered
      no-close-on-backdrop
      no-close-on-esc
    >
      <div
        class="d-flex justify-content-between top-modal"
        style="margin-top: 10px;"
      >
        <div>
          <h4 class="font-medium text-primary">
            {{ $t('campaign.duplicateCampaign.titleModal') }}
          </h4>
          <p class="mb-0 text-placeholder">
            {{ !isSetupView ? $t('campaign.duplicateCampaign.subtitleModal', { campaignName: campaignDuplicate.campaign_name }) : $t('campaign.duplicateCampaign.textReview') }}
          </p>
        </div>
        <div>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hideModal"
          />
        </div>
      </div>
      <div
        class="duplicate-campaign-content mt-2"
        style="height: calc(100% - 100px); overflow-y: scroll"
      >
        <div>
          <validation-observer
            ref="formValidation"
          >
            <b-form
              class="form mt-2 mx-auto"
              @submit.prevent="showSetupView"
            >
              <b-form-group class="my-1 position-relative form-label">
                <template #label>
                  <span
                    class="font-weight-600"
                    style="font-size: 18px;"
                  >
                    {{ $t('campaign.duplicateCampaign.textNumberOfDuplicates') }}
                  </span>
                </template>
                <validation-provider
                  #default="{ errors }"
                  :name="$t('campaign.duplicateCampaign.textNumberOfDuplicates')"
                  rules="required|between:1,10"
                >
                  <b-input-group
                    class="d-flex align-items-center"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    style="width: 190px"
                  >
                    <b-input-group-prepend>
                      <b-button
                        :disabled="Number(numberOfDuplicates) <= 1"
                        variant="outline-secondary"
                        :class="{'cursor-not-allowed': Number(numberOfDuplicates) <= 1}"
                        style="height: 42px; border-radius: 8px 0 0 8px; border-color: #e0e0e5 !important;"
                        @click="decrementDuplicates"
                      >
                        -
                      </b-button>
                    </b-input-group-prepend>
                    <b-form-input
                      v-model.number="numberOfDuplicates"
                      :name="$t('campaign.duplicateCampaign.textNumberOfDuplicates')"
                      style="height: 42px; text-align: center"
                      placeholder=""
                      :state="errors.length > 0 ? false : null"
                    />

                    <b-input-group-append>
                      <b-button
                        :disabled="Number(numberOfDuplicates) >= 10"
                        variant="outline-secondary"
                        :class="{'cursor-not-allowed': Number(numberOfDuplicates) >= 10}"
                        style="height: 42px; border-radius: 0 8px 8px 0; border-color: #e0e0e5 !important;"
                        @click="incrementDuplicates"
                      >
                        +
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <p
                class="font-weight-600"
                style="font-size: 18px;"
              >
                {{ $t('campaign.duplicateCampaign.textListCampaign') }}
              </p>
              <div
                v-for="(campaign, index) in listCampaignName"
                :key="index"
              >
                <b-form-group
                  class="my-1 position-relative form-label"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('campaign.duplicateCampaign.textNumberOfDuplicates')"
                    rules="required"
                  >
                    <b-input-group
                      class=""
                      :class="errors.length > 0 ? 'is-invalid' : null"
                    >
                      <b-form-input
                        v-model="campaign.campaignName"
                        :name="$t('campaign.duplicateCampaign.textNumberOfDuplicates')"
                        class="input-height"
                        placeholder=""
                        :state="errors.length > 0 ? false : null"
                      />
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </div>
              <div
                id="tooltip-generate-btn"
                class="d-flex justify-content-center mt-2"
              >
                <btn-loading
                  class="ml-1"
                  variant-convert="btn-submit"
                  type="submit"
                  pill
                  :disabled="Number(numberOfDuplicates) < 1 || Number(numberOfDuplicates) > 10 || totalAdGroup === 0 || invalidLeadGeneration"
                >
                  Generate & Edit
                </btn-loading>
                <b-tooltip
                  v-if="totalAdGroup === 0 || invalidLeadGeneration"
                  target="tooltip-generate-btn"
                  triggers="hover"
                  variant="light"
                >
                  <span v-if="totalAdGroup === 0">
                    This campaign has no ad group.
                  </span>
                  <span v-if="invalidLeadGeneration">
                    Currently, we only support the optimization locations Website and Instant Form.
                  </span>
                </b-tooltip>
              </div>
            </b-form>
          </validation-observer>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import {
  BForm, BFormGroup, BFormInput, BInputGroup, BModal, BInputGroupAppend, BButton, BInputGroupPrepend, BTooltip,
} from 'bootstrap-vue'
import BtnLoading from '@/layouts/components/BtnLoading.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import get from 'lodash/get'

const { mapActions, mapGetters } = createNamespacedHelpers('campaign')

export default {
  components: {
    BTooltip,
    BFormGroup,
    ValidationProvider,
    ValidationObserver,
    BInputGroup,
    BForm,
    BFormInput,
    BtnLoading,
    BModal,
    BInputGroupAppend,
    BInputGroupPrepend,
    BButton,
  },
  props: {
    campaignDuplicate: {
      type: Object,
      default: () => {},
      required: true,
    },

    advertiserId: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      numberOfDuplicates: 1,
      isSetupView: false,

      listCampaignName: [],
    }
  },

  computed: {
    ...mapGetters(['listAdGroupCampaign', 'status', 'message', 'loading']),
    totalAdGroup() {
      return get(this.listAdGroupCampaign, ['paging', 'total'], 0)
    },

    invalidLeadGeneration() {
      if (this.campaignDuplicate.objective_type === 'LEAD_GENERATION') {
        return !!get(this.listAdGroupCampaign, ['content'], []).find(item => item.promotion_type !== 'LEAD_GENERATION')
      }
      return false
    },
  },

  watch: {
    campaignDuplicate(val) {
      if (val && val.campaign_id) {
        const params = {
          advertiserId: this.advertiserId.value,
          campaignIds: val?.campaign_id,
          page: 1,
          size: 100,
        }
        this.getListAdGroupCampaign(params)
        this.initializeCampaigns()
      }
    },

    numberOfDuplicates(newValue, oldValue) {
      this.adjustCampaignsArray(newValue, oldValue)
    },
  },

  methods: {
    ...mapActions(['getListAdGroupCampaign']),
    initializeCampaigns() {
      this.listCampaignName = [{
        campaignName: `Copy 1 of ${this.campaignDuplicate.campaign_name}`,
      }]
    },

    adjustCampaignsArray(newValue, oldValue) {
      const newCount = Number(newValue)
      const oldCount = Number(oldValue)

      if (newCount > oldCount) {
        for (let i = oldCount; i < newCount; i += 1) {
          this.listCampaignName.push({
            campaignName: `Copy ${i + 1} of ${this.campaignDuplicate.campaign_name}`,
          })
        }
      } else if (newCount < oldCount) {
        this.listCampaignName.splice(newCount)
      }
    },

    decrementDuplicates() {
      if (this.numberOfDuplicates > 1) {
        this.numberOfDuplicates = Number(this.numberOfDuplicates) - 1
      }
    },

    incrementDuplicates() {
      this.numberOfDuplicates = Number(this.numberOfDuplicates) + 1
    },

    resetModal() {
      this.numberOfDuplicates = 1
      this.isSetupView = false
      this.listCampaignName = []
    },

    hideModal() {
      this.$refs['duplicate-campaign-modal'].hide()
      this.resetModal()
    },

    showModal() {
      this.$refs['duplicate-campaign-modal'].show()
      this.initializeCampaigns()
    },

    showSetupView() {
      this.$router.push(`/campaign/duplicate?campaignDuplicate=${this.campaignDuplicate.campaign_id}&listCampaignName=${this.listCampaignName.map(c => c.campaignName).join(',-,')}&advertiserId=${this.advertiserId.value}&isNew=true`)
    },
  },
}
</script>
<style lang="scss">
#duplicate-campaign-modal {
  .modal-content {
    height: 90vh;

    .modal-body {
      height: 100%;
    }

    .form-control:focus, .input-group:focus-within .form-control {
      border-color: #e0e0e5 !important;
    }
  }
}
</style>
